import {Component, OnDestroy} from '@angular/core';
import {ObjectList} from '../../model/object-list';
import {LeadSource} from '../../model/lead-source';
import {LeadSourcesResource} from '../../model/model-resource';

@Component({
  selector: 'app-lead-sources-list-page',
  templateUrl: './lead-sources-list-page.component.html',
  styleUrls: ['./lead-sources-list-page.component.scss']
})
export class LeadSourcesListPageComponent implements OnDestroy {

  leadSources: ObjectList<LeadSource>;
  columns = ['name', 'created', 'actions'];

  constructor(private resource: LeadSourcesResource) {
    this.leadSources = new ObjectList<LeadSource>('leadSources', this.resource);
  }

  ngOnDestroy() {
    this.leadSources.disconnect();
    this.leadSources = null;
  }

}
